export default {
  windowWidth: state => state.window.width,
  windowHeight: state => state.window.height,
  colorA: state => state.colors.a,
  colorB: state => state.colors.b
}
